import { render, staticRenderFns } from "./numberList.vue?vue&type=template&id=52b019bf&scoped=true&"
import script from "./numberList.vue?vue&type=script&lang=js&"
export * from "./numberList.vue?vue&type=script&lang=js&"
import style0 from "./numberList.vue?vue&type=style&index=0&id=52b019bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b019bf",
  null
  
)

export default component.exports